/**
 * Created by hb on 2019/5/5.
 */
import _ from 'lodash'
import moment from 'moment'
import { message } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { flightCities } from '@/assets/js/data'
import { fetchOnlineCity } from '@/apis/flight'
import fetchFares from './utils/fetch'

export default {
  name: 'common-flight-search-menu',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: 'common'
    },
    hideMulti: {
      type: Boolean,
      default: true
    },
    hideTripRadio: {
      type: Boolean,
      default: true
    },
    isSupportonlineCity: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: 'Booking_选择航班'
    }
  },
  data () {
    return {
      tripType: 'ONEWAY', // ONEWAY | ROUNDTRIP | MULTIWAY
      cabin: 'Economy',
      depCode: '',
      arrCode: '',
      isDepInternational: false,
      isArrInternational: false,
      depCityOpen: false,
      depDateOpen: false,
      arrDateOpen: false,
      depDate: moment(),
      arrDate: moment(),
      originDestinations: [],
      now: '',
      passenger: { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 },
      isJJC: false,
      jjcShow: false,
      jjcTips: '',
      // jjcBackup: null,
      locale: zhCN,
      citiesData: [],
      citiesDataDep: [],
      citiesDataArr: [],
      onlineCityData: [],
      arrLoading: true,
      arrType: 'city',
      depType: 'city',
      arrVisible: false,
      depVisible: false,
      arrivalDefaultValue: moment().add(2, 'd')
    }
  },
  created () {
    const now = new Date().getTime()
    this.depDate = this.now = moment(now)
    const { value } = this

    if (!_.isEmpty(value)) {
      const { tripType, originDestinations, passenger } = value

      if (tripType !== 'MULTIWAY' && originDestinations) {
        if (originDestinations[0].depCode) {
          this.depCode = originDestinations[0].depCode
        }

        if (originDestinations[0].arrCode) {
          this.arrCode = originDestinations[0].arrCode
        }

        if (originDestinations[0].depType) {
          this.depType = originDestinations[0].depType
        }

        if (originDestinations[0].arrType) {
          this.arrType = originDestinations[0].arrType
        }

        if (originDestinations[0].flightDate) {
          this.depDate = moment(originDestinations[0].flightDate)
          this.arrDate = moment(originDestinations[0].flightDate).add(2, 'd')
        }

        if (tripType === 'ROUNDTRIP' && originDestinations[1].flightDate) {
          this.arrDate = moment(originDestinations[1].flightDate)
        }

        this.handleIsInternational(originDestinations)
      }

      if (originDestinations) {
        this.originDestinations = originDestinations
      }

      if (passenger) {
        this.passenger = passenger
      }

      this.tripType = tripType || 'ONEWAY'
    }

    this.getData()
    this.getCmsData()
    if (!this.depCode) {
      this.location()
    } else {
      this.getOnlineCityData(this.depCode, this.depType)
    }
  },
  mounted () {
    const { passenger } = this

    if (passenger.MWD || passenger.PWD) {
      this.isJJC = true
      this.jjcShow = true
    }
  },
  watch: {
    // 根据tab选择类型初始化人数
    type: {
      handler: function (newValue) {
        this.isJJC = newValue === 'jjc'
        if (!this.isJJC) {
          this.passenger = Object.assign({}, this.passenger, { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 })
        } else {
          this.passenger = Object.assign({}, this.passenger, { ADT: 0, CNN: 0, INF: 0, MWD: 1, PWD: 0 })
        }
      },
      deep: true,
      immediate: true
    },
    tripType: {
      handler: function (newValue) {
        if (newValue && newValue === 'ROUNDTRIP') {
          this.arrDate = moment(new Date()).add(2, 'd')
        } else {
          this.arrDate = null
        }
      },
      deep: true,
      immediate: true
    },
    departure: {
      handler: function (newValue) {
        if (!_.some(newValue, _.isEmpty)) {
          this.fetchData()
        }
      }
    }
  },
  computed: {
    departure () {
      const { depCode, arrCode, depDate } = this
      return { depCode, arrCode, depDate }
    }
  },
  methods: {
    async getCmsData () {
      try {
        const cmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) || {}
        this.jjcTips = _.get(cmsData, 'jjc-tips.content')
      } catch (err) {}
    },
    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.citiesDataDep = _.cloneDeep(cities)
        this.citiesDataArr = _.cloneDeep(cities)
        this.citiesData = _.cloneDeep(cities)
      }
    },
    async getOnlineCityData (value, valueType) {
      if (!this.isSupportonlineCity || !value || !valueType) {
        return false
      }
      this.onlineCityData = []
      this.citiesDataArr = []
      this.arrLoading = true
      try {
        const params = {
          depCode: value,
          depType: valueType
        }
        this.onlineCityData = await fetchOnlineCity(params) || []
        const citiesData = this.onlineCityData.length > 0 ? this.onlineCityData : this.citiesData
        this.citiesDataArr.splice(0, this.citiesData.length, ..._.uniqBy(citiesData, 'name'))
        this.arrLoading = false
      } catch (error) {
        this.resetCityData()
        this.arrLoading = false
      }
    },
    resetCityData (isAll = true) {
      if (!this.isSupportonlineCity) {
        return false
      }
      const { citiesData, onlineCityData } = this
      const cities = !isAll && onlineCityData.length > 0 ? onlineCityData : citiesData
      this.citiesDataArr.splice(0, this.citiesData.length, ..._.uniqBy(cities, 'name'))
    },
    async search () {
      window.__MICRO_ROOT__?.api?.track?.('home_flightsearch')
      const { tripType, passenger } = this
      let originDestinationList = []

      if (tripType !== 'MULTIWAY') {
        const { depCode, arrCode, depType, arrType, depDate, arrDate } = this

        if (depCode === '') {
          message.error('请先选择出发城市')
          return
        }

        if (arrCode === '') {
          message.error('请先选择到达城市')
          return
        }

        if (depDate === '') {
          message.error('请先选择出发日期')
          return
        }

        if (arrCode === depCode) {
          message.error('出发地和目的地不能相同')
          return
        }

        originDestinationList.push({
          depCode,
          arrCode,
          depType,
          arrType,
          flightDate: moment(depDate).format('YYYY-MM-DD')
        })

        if (tripType === 'ROUNDTRIP') {
          if (arrDate === '') {
            message.error('请先选择返回日期')
            return
          }

          originDestinationList.push({
            depCode: arrCode,
            arrCode: depCode,
            depType: arrType,
            arrType: depType,
            flightDate: moment(arrDate).format('YYYY-MM-DD')
          })
        }
      } else {
        const { originDestinations } = this
        let item

        for (let i = 0, len = originDestinations.length; i < len; i++) {
          item = originDestinations[i]

          if (item.depCode === '') {
            message.error(`请先选择第${i + 1}程出发城市`)
            return
          }

          if (item.arrCode === '') {
            message.error(`请先选择第${i + 1}程到达城市`)
            return
          }

          if (item.flightDate === '') {
            message.error(`请先选择第${i + 1}程出发日期`)
            return
          }

          if (item.arrCode === item.depCode) {
            message.error(`出发地和目的地不能相同`)
            return
          }
        }

        if (originDestinations[1].flightDate < originDestinations[0].flightDate) {
          message.error(`第2程出发日期要晚于第1程`)
          return
        }

        originDestinationList = originDestinations
      }

      await this.handleIsInternational(originDestinationList)

      const data = {
        tripType,
        passenger,
        originDestinations: originDestinationList,
        isInternational: this.isDepInternational || this.isArrInternational
      }

      // if (passenger.MWD || passenger.PWD) {
      //   // this.jjcShow = true
      //   this.jjcBackup = data
      //   // return
      // }

      // if (this.jjcBackup) {
      //   this.$emit('search', this.jjcBackup)
      // }

      let tracelogSearch = []

      originDestinationList.forEach(item => {
        tracelogSearch.push(`${item.depCode}_${item.arrCode}_${item.flightDate}`)
      })

      for (let key in passenger) {
        tracelogSearch.push(passenger[key])
      }

      this.$emit('search', data)
    },
    onDepDateChange (value) {
      this.depDateOpen = false
      this.arrDate = moment(value).add(2, 'd')

      if (this.tripType === 'ROUNDTRIP') {
        // this.$refs.arrCalendar.$refs.input.focus()
        this.arrDateOpen = true
      }
    },
    onArrDateChange (value) {
      if (value) {
        this.tripType = 'ROUNDTRIP'
      } else {
        this.tripType = 'ONEWAY'
      }
    },
    onDepCodeChange (value, city, valueType) {
      this.depVisible = false
      if (value) {
        this.arrVisible = true
        this.isDepInternational = !!city.other
        this.depType = valueType
        this.getOnlineCityData(value, valueType)
      } else {
        this.resetCityData()
      }
    },
    onArrCodeChange (value, city, valueType) {
      this.arrVisible = false
      if (value) {
        // this.depDateOpen = true
        this.isArrInternational = !!city.other
        this.arrType = valueType
      } else {
        this.resetCityData(false)
      }
    },
    switchCity (e, index) {
      e.preventDefault()

      if (typeof index === 'undefined') {
        ;[this.depCode, this.arrCode] = [this.arrCode, this.depCode]
        ;[this.depType, this.arrType] = [this.arrType, this.depType]
        this.getOnlineCityData(this.depCode, this.depType)
      } else {
        const { originDestinations } = this
        const data = originDestinations[index]
        ;[data.depCode, data.arrCode] = [data.arrCode, data.depCode]
        ;[data.depType, data.arrType] = [data.arrType, data.depType]
        originDestinations.splice(index, 1, data)
        this.getOnlineCityData(this.depCode, data.depType)
      }
    },
    // 接替onChangeType,当tripType='MULTIWAY'时,拼装参数且跳转到航班查询页
    selectTripType () {
      const { tripType, passenger, depCode, arrCode, depDate, isDepInternational, isArrInternational, now } = this

      if (tripType === 'MULTIWAY') {
        this.originDestinations = [
          {
            depCode: depCode || '',
            arrCode: arrCode || '',
            flightDate: depDate || now
          },
          {
            depCode: '',
            arrCode: '',
            flightDate: depDate ? moment(depDate).add(2, 'd') : now
          }
        ]
        const data = {
          tripType,
          passenger: passenger,
          originDestinations: this.originDestinations,
          isInternational: isDepInternational || isArrInternational
        }
        this.$emit('search', data)
      }
    },
    // 暂时弃用
    onChangeType () {
      const { tripType, originDestinations, depCode, arrCode, depDate, now } = this

      if (tripType === 'MULTIWAY') {
        this.tripType = 'ONEWAY'
        this.depCode = originDestinations[0].depCode || ''
        this.arrCode = originDestinations[0].arrCode || ''
        this.depDate = originDestinations[0].flightDate || now
        this.arrDate = moment(originDestinations[0].flightDate || now).add(2, 'd')
      } else {
        this.tripType = 'MULTIWAY'
        this.passenger = { ADT: 1, CNN: 0, INF: 0, MWD: 0, PWD: 0 }
        this.originDestinations = [
          {
            depCode: depCode || '',
            arrCode: arrCode || '',
            flightDate: depDate || now
          },
          {
            depCode: '',
            arrCode: '',
            flightDate: depDate ? moment(depDate).add(2, 'd') : now
          }
        ]
      }
    },
    handleOk () {
      this.jjcShow = false

      // if (this.jjcBackup) {
      //   this.$emit('search', this.jjcBackup)
      // }
    },
    // 定位
    async location () {
      try {
        let city = await window.__MICRO_ROOT__?.api?.location()
        if (city) {
          // 获取code
          flightCities().then(cities => {
            city = _.find(cities, { city })

            if (city) {
              const { depType } = this
              this.depCode = depType === 'city' ? city.cityCode : city.code
              this.getOnlineCityData(this.depCode, depType)
            }
          })
        }
      } catch (err) {
        console.error('location error:: ', err)
      }
    },
    fetchData () {
      const { depCode = '', arrCode = '', depDate } = this
      return fetchFares(depCode, arrCode, depDate)
    },
    // 判断是否国际航班查询
    handleIsInternational (originDestinations) {
      flightCities().then(cities => {
        const orgDst = originDestinations[0]
        const depCity = _.find(cities, orgDst.depType === 'city' ? { cityCode: orgDst.depCode } : { code: orgDst.depCode }) ?? {}
        const arrCity = _.find(cities, orgDst.arrType === 'city' ? { cityCode: orgDst.arrCode } : { code: orgDst.arrCode }) ?? {}
        this.isDepInternational = depCity.other ?? false
        this.isArrInternational = arrCity.other ?? false
      })
    }
  }
}
